<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import moment from "moment";
import $ from "jquery";
import RerunRounds from "@/components/Dashboard/Courses/Modals/RerunRounds.vue";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();

const loading = computed(() => store.getters["course/isRerunRoundsLoading"]);
const openModal = ref(false);
const startDate = ref(moment().format("YYYY-MM-DD"));
const endDate = ref(moment().format("YYYY-MM-DD"));

function initializeDatepicker() {
  $("#rerunRoundsDatepicker").daterangepicker(
    {
      startDate: moment(startDate.value),
      endDate: moment(endDate.value),
      maxDate: moment(),
      drops: "up",
      opens: "right",
      parentEl: "body",
      locale: {
        cancelLabel: "Clear",
        applyLabel: "Apply",
        format: "DD MMM YYYY",
      },
    },
    function (start, end) {
      startDate.value = start.format("YYYY-MM-DD");
      endDate.value = end.format("YYYY-MM-DD");
    }
  );
}

onMounted(async () => {
  initializeDatepicker();
});

const rerunRounds = () => {
  openModal.value = true;
};
</script>

<template>
  <div class="pt-3 pb-4 pl-2">
    <div class="row">
      <div class="col-12 col-md-4">
        <input
          type="text"
          placeholder="Date"
          id="rerunRoundsDatepicker"
          class="form-control"
        />
      </div>
      <div class="col-12 col-md-2 mt-2 mt-md-0">
        <button
          @click="rerunRounds()"
          class="btn btn-primary rerun-rounds"
          :disabled="loading"
        >
          <font-awesome-icon v-show="loading" :icon="['fas', 'spinner']" spin />
          <span v-show="!loading">Rerun Rounds</span>
        </button>
      </div>
    </div>
    <RerunRounds
      :model-value="openModal"
      :startDate="startDate"
      :endDate="endDate"
      :course-id="route.params.id"
      @update:modelValue="openModal = false"
    />
  </div>
</template>

<style>
.rerun-rounds {
  width: 180px;
}
</style>
